<ng-container *ngIf="product$ | async as product">
  <div class="mode-overlay" *ngIf="mode === 'view'">
    <!-- overlay prevents edits in view mode -->
  </div>
  <mat-tab-group>
    <mat-tab label="Product">
      <div class="product-tab-grid">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Description</mat-label>
          <input matInput [(ngModel)]="product.Description" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="fixed-field">
          <mat-label>Product Code</mat-label>
          <input matInput [(ngModel)]="product.Code" />
        </mat-form-field>

        <div class="span-two coo-row">
          <app-country-object-lookup
            label="Country of Origin"
            [id]="product.CountryOfOrigin"
            (idChange)="product.CountryOfOrigin = $any($event)"
          >
          </app-country-object-lookup>

          <button mat-stroked-button color="accent" [disabled]="!product.ProductID" (click)="viewNotes()">View Notes</button>
        </div>

        <app-supplier-object-lookup
          label="Supplier"
          [id]="product.Supplier"
          (idChange)="product.Supplier = $any($event)"
          class="span-two"
        >
        </app-supplier-object-lookup>

        <mat-form-field appearance="outline" class="date-field">
          <mat-label>Last Updated</mat-label>
          <input matInput [(ngModel)]="product.LastUpdated" readonly />
        </mat-form-field>

        <app-status-object-lookup
          label="Status"
          [id]="product.Status"
          (idChange)="product.Status = $any($event)"
        >
        </app-status-object-lookup>

        <mat-form-field appearance="outline" class="date-field">
          <mat-label>Last Supplied</mat-label>
          <input matInput [(ngModel)]="product.LastSupplied" readonly />
        </mat-form-field>

        <mat-form-field appearance="outline" class="date-field">
          <mat-label>Data Source</mat-label>
          <input matInput [(ngModel)]="product.DataSource" readonly />
        </mat-form-field>

        <mat-form-field appearance="outline" class="fixed-field">
          <mat-label>Hazard Class</mat-label>
          <input matInput [(ngModel)]="product.Hazardous" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="date-field">
          <mat-label>Last Imported</mat-label>
          <input matInput [(ngModel)]="product.LastImported" readonly />
        </mat-form-field>

        <mat-form-field appearance="outline" class="date-field">
          <mat-label>Pricing Expires</mat-label>
          <input matInput [(ngModel)]="product.PricingExpiry" readonly />
        </mat-form-field>

        <app-hscode-object-lookup
          label="HS Tariff"
          [id]="product.HSCode"
          (idChange)="product.HSCode = $any($event)"
          class="full-width"
        >
        </app-hscode-object-lookup>
      </div>
    </mat-tab>

    <mat-tab label="Codes">
      <div class="codes-tab">
        <mat-list class="product-codes">
          <mat-list-item *ngFor="let code of product.ProductCodes" (click)="selectCode(code)" [class.active]="selectedCode === code">
            <span [class.active]="selectedCode === code">{{ code }}</span>
          </mat-list-item>
        </mat-list>

        <div class="code-buttons">
          <button mat-stroked-button color="primary" (click)="addCode()">Add</button>
          <button mat-stroked-button color="warn" (click)="deleteCode()">Delete</button>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Pricing">
      <div class="pricing-tab">
        <div class="pricing-fields-grid">
          <mat-form-field appearance="outline" class="span-three">
            <mat-label>Catalogue Name</mat-label>
            <input matInput [(ngModel)]="product.CatName" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Catalogue Page</mat-label>
            <input matInput [(ngModel)]="product.CatPage" />
          </mat-form-field>

          <app-currency-object-lookup
            label="Currency"
            [id]="product.Currency"
            (idChange)="product.Currency = $any($event)"
          >
          </app-currency-object-lookup>

          <app-unitsize-object-lookup
            label="Unit"
            [id]="product.UnitType"
            (idChange)="product.UnitType = $any($event)"
            class="span-two"
          >
          </app-unitsize-object-lookup>

          <mat-form-field appearance="outline">
            <mat-label>Unit Size</mat-label>
            <input matInput [(ngModel)]="product.UnitAmount" />
          </mat-form-field>
          
          <app-commodity-object-lookup
            label="Commodity"
            [id]="product.Commodity"
            (idChange)="product.Commodity = $any($event)"
          >
          </app-commodity-object-lookup>
          
          <div class="span-two unit-name">{{ currentUnitString$ | async }}</div>
        </div>

        <div class="pricing-panel">
          <div>
            <mat-form-field appearance="outline" class="catalogue-price">
              <mat-label>Catalogue Price</mat-label>
              <input matInput type="number" [(ngModel)]="product.Cost" />
            </mat-form-field>
            <mat-radio-group [(ngModel)]="pricingMode">
              <mat-radio-button value="discount">
                <mat-form-field appearance="outline" [ngClass]="{readonly: pricingMode !== 'discount'}">
                  <mat-label>Discount %</mat-label>
                  <input matInput type="number" step="0.1" min="0" max="100" [value]="product.Discount * 100" (input)="discountChanged($any($event.target))" [readonly]="pricingMode !== 'discount'" />
                </mat-form-field>
              </mat-radio-button>
              <mat-radio-button value="price">
                <mat-form-field appearance="outline" [ngClass]="{readonly: pricingMode !== 'price'}">
                  <mat-label>Trade Price</mat-label>
                  <input matInput type="number" step="0.01" min="0" [value]="tradePrice" (input)="tradePriceChanged($any($event.target))" [readonly]="pricingMode !== 'price'" />
                </mat-form-field>
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <div>
            <mat-checkbox [checked]="manualPricing" (change)="manualPricingChanged($event)">Manual Pricing</mat-checkbox>
            <mat-form-field appearance="outline" [ngClass]="{readonly: !manualPricing}">
              <mat-label>Sale Price</mat-label>
              <input matInput type="number" [(ngModel)]="product.Price" [readonly]="!manualPricing" />
            </mat-form-field>
            <div>
              <span>Profit:</span>
              <span>{{ product.Price - (product.Cost * (1 - product.Discount)) | number: '1.2-2' }}</span>
            </div>
            <div>
              <span>Margin:</span>
              <span>{{ ((product.Price - (product.Cost * (1 - product.Discount))) / product.Price) | percent: '1.0-2' }}</span>
            </div>
          </div>

          <div class="markup-buttons">
            <button mat-stroked-button (click)="markUp10()">10% M/U</button>
            <button mat-stroked-button (click)="markUp15()">15% M/U</button>
            <button mat-stroked-button (click)="markUp20()">20% M/U</button>
            <button mat-stroked-button (click)="markUp25()">25% M/U</button>
          </div>

          <div class="pricing-button-grid">
            <button mat-stroked-button (click)="updatePrice()">Reset Pricing</button>
            <div>
              <button mat-stroked-button color="primary" (click)="confirmPricing()" class="confirm-pricing">Pricing Confirmed OK</button>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Stock">
      <div class="stock-tab-grid">
        <mat-form-field appearance="outline">
          <mat-label>Stock Level</mat-label>
          <input matInput type="number" [(ngModel)]="product.Stock" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Stock Location</mat-label>
          <input matInput [(ngModel)]="product.StockLocation" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Weight</mat-label>
          <input matInput type="number" [(ngModel)]="product.Weight" />
        </mat-form-field>
        <mat-checkbox [(ngModel)]="product.WVerified">Weight Verified</mat-checkbox>

        <mat-form-field appearance="outline">
          <mat-label>Volume</mat-label>
          <input matInput type="number" [(ngModel)]="product.Volume" />
        </mat-form-field>
        <mat-checkbox [(ngModel)]="product.VVerified">Volume Verified</mat-checkbox>

        <mat-form-field appearance="outline">
          <mat-label>Supply Time</mat-label>
          <input matInput [(ngModel)]="product.SupplyTime" />
        </mat-form-field>
      </div>
    </mat-tab>

    <mat-tab label="Image">
      <div class="image-tab-grid">
        <div class="image-preview">
          <img [src]="product.ImageUrlDetail || product.ImageUrlList" alt="Product Image" />
        </div>

        <div class="image-source-group">
          <div class="image-controls">
            <button mat-stroked-button>Load Image</button>
            <button mat-stroked-button>Reset Image</button>
          </div>
          <div class="image-search">
            <mat-form-field appearance="outline">
              <mat-label>Image URL</mat-label>
              <input matInput [(ngModel)]="product.ImageUrlDetail" />
            </mat-form-field>
            <button mat-stroked-button>Search</button>
          </div>
          <fieldset class="source-groupbox">
            <legend>Source</legend>
            <mat-radio-group [(ngModel)]="imageSourceMode">
              <mat-radio-button value="link">Link</mat-radio-button>
              <mat-radio-button value="local">Local Image</mat-radio-button>
            </mat-radio-group>          
          </fieldset>
          <div class="image-controls">
            <button mat-stroked-button>Add Image</button>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</ng-container>
